/** Where the signup "Contact Sales" form sends Enterprise plan inquiries. */
export const ENTERPRISE_INQUIRY_RECIPIENT = "info@versafy.ai"
